import { NgModule } from '@angular/core';
import { AllocationUserName } from '@shared/pipes/allocation-username.pipe';
import { ChipsListPipe } from '@shared/pipes/chips-list.pipe';
import { CustomFieldOptionsPipe } from '@shared/pipes/custom-field-options.pipe';
import { EscapeHtmlPipe } from '@shared/pipes/keep-html.pipe';
import { LanguageTranslation } from '@shared/pipes/language-translation.pipe';
import { LimitLoop } from '@shared/pipes/limit-loop.pipe';
import { AllocationStatusPipe } from './allocation-status.pipe';
import { ChartStatusPipe } from './chart-status.pipe';
import { CurrencyPipe, CurrencyLabelPipe} from './currency-label.pipe';
import { FilterArrayPipe } from './filter-array.pipe';
import { FilterForMultiselectPipe } from './filter-for-multiselect.pipe';
import { HardcodedTranslationPipe } from './hardcoded-translation.pipe';
import { HasVenuesOnlinePipe } from './has-venues-online.pipe';
import { IconPipe } from './icon.pipe';
import { ItemsForChartPipe } from './items-for-chart.pipe';
import { ItemsForRatingChartPipe } from './items-for-rating-chart.pipe';
import { LanguagePipe } from './language.pipe';
import { LocalePipe } from './locale.pipe';
import { OwnerPipe } from './owner.pipe';
import { PaymentChargeAmountPipe } from './payment-charge-amount.pipe';
import { SqrtPipe } from './sqrt.pipe';
import { TimezoneLabelPipe } from './timezone-label.pipe';
import { ValidTime } from './valid-time.pipe';
import { VenueStatusPipe } from './venue-status.pipe';
import { SplitPipe } from './split.pipe';
import { ActivityTypePipe } from './activity-type.pipe';
import { ContainsPipe } from './contains.pipe';
import { TicketTypePipe } from './ticket-type.pipe';
import { AttendeeStatusTypePipe } from './attendee-statustype.pipe';
import { InvitationStatusTypePipe } from './invitation-statustype.pipe';
import { AttendeeTicketStatusTypePipe } from './ticket-statustype.pipe';
import { AuthenticationTypePipe } from './authenticationtype.pipe';
import { ReportTypePipe } from './report-type.pipe';
import { CountryTranslation } from './country-translation-pipe';
import { ColumnWidthPipe } from './columnWidth.pipe';
import { TranslationsIndexPipe } from './translations-index.pipe';
import { ColumnResponsivePipe } from './columnResponsive.pipe';
import { AlignmentTypePipe } from './alignment-type.pipe';
import { FilterContentUrlPipe } from './filter-content-url.pipe';
import { FilterFooterPipe } from './filter-footer.pipe';
import { FormatTagsPipe } from './format-tags.pipe';
import { FileAcceptPipe } from './file-accept.pipe';
import { FilterFooterTypePipe } from './filter-footer-type.pipe';
import { AlignmentFlexTypePipe } from './alignment-flex-type.pipe';
import { FilterContentFilePipe } from './filter-content-file.pipe';
import { PromotionTypePipe } from './promotion-type.pipe';
import { ExportTypePipe } from './export-type.pipe';
import { ShortFileNamePipe } from './short-filename.pipe';

@NgModule({
    declarations: [
        EscapeHtmlPipe, AllocationUserName, LanguageTranslation, CountryTranslation, FilterArrayPipe, CustomFieldOptionsPipe,
        FilterForMultiselectPipe, ChipsListPipe, ItemsForChartPipe, ItemsForRatingChartPipe, LimitLoop, OwnerPipe,
        ChartStatusPipe, VenueStatusPipe, AllocationStatusPipe, ValidTime, LanguagePipe, SqrtPipe, HasVenuesOnlinePipe,
        HardcodedTranslationPipe, LocalePipe, TimezoneLabelPipe, IconPipe, PaymentChargeAmountPipe, CurrencyLabelPipe,
        SplitPipe, ActivityTypePipe, ContainsPipe, TicketTypePipe, AttendeeStatusTypePipe, InvitationStatusTypePipe,
        AttendeeTicketStatusTypePipe, AuthenticationTypePipe, ReportTypePipe, ColumnWidthPipe, TranslationsIndexPipe,
        ColumnResponsivePipe, AlignmentTypePipe, FilterContentUrlPipe, FilterFooterPipe, FormatTagsPipe, FileAcceptPipe,
        FilterFooterTypePipe, AlignmentFlexTypePipe, FilterContentFilePipe, PromotionTypePipe, ExportTypePipe, ShortFileNamePipe,
        CurrencyPipe,
    ],
    exports: [
        EscapeHtmlPipe, AllocationUserName, LanguageTranslation, CountryTranslation, FilterArrayPipe, CustomFieldOptionsPipe,
        FilterForMultiselectPipe, ChipsListPipe, ItemsForChartPipe, ItemsForRatingChartPipe, LimitLoop, OwnerPipe,
        ChartStatusPipe, VenueStatusPipe, AllocationStatusPipe, ValidTime, LanguagePipe, SqrtPipe, HasVenuesOnlinePipe,
        HardcodedTranslationPipe, LocalePipe, TimezoneLabelPipe, IconPipe, PaymentChargeAmountPipe, CurrencyLabelPipe,
        SplitPipe, ActivityTypePipe, ContainsPipe, TicketTypePipe, AttendeeStatusTypePipe, InvitationStatusTypePipe,
        AttendeeTicketStatusTypePipe, AuthenticationTypePipe, ReportTypePipe, ColumnWidthPipe, TranslationsIndexPipe,
        ColumnResponsivePipe, AlignmentTypePipe, FilterContentUrlPipe, FilterFooterPipe, FormatTagsPipe, FileAcceptPipe,
        FilterFooterTypePipe, AlignmentFlexTypePipe, FilterContentFilePipe, PromotionTypePipe, ExportTypePipe, ShortFileNamePipe,
        CurrencyPipe,
    ],
    providers: [
        ActivityTypePipe, LanguagePipe
    ]
})
export class CustomPipesModule { }
